export const footerData = [
    {
      title: "Telecel Ghana",
      children: [
        { title: "Personal", link: "/" },
        { title: "Business", link: "/business/" },
        {
          title: "About Us",
          link: "/explore-telecel/",
        },
        // {
        //   title: "Career",
        //   link: "https://vodafone.com.gh/explore-vodafone/careers/",
        // },
        // {
        //   title: "Telecel Foundation",
        //   link: "https://vodafone.com.gh/explore-vodafone/foundation/",
        // },
      ],
    },
    {
      title: "Help & Support",
      children: [
        // {
        //   title: "E-levy FAQs",
        //   link: "https://support.telecel.com.gh/help/e-levy-faqs/",
        // },
        // {
        //   title: "Fault Reporting",
        //   link: "https://play.telecel.com.gh/fault-reporting/",
        // },
        // {
        //   title: "Frequently Asked Questions",
        //   link: "https://support.telecel.com.gh/topic/faqs/",
        // },
        // {
        //   title: "Call Detail Record Request",
        //   link: "https://cdr.vodafone.com.gh/",
        // },
        {
          title: "Find a shop",
          // link: "/personal/mobile/shop/devices",
          link: "https://support.telecel.com.gh/help/retailshop/",
        },
        {
          title: "Contact us",
          link: "/contact-us/",
        },
        {
          title: "Privacy Policy",
          link: "/privacy-policy/",
          // link: "/business/privacy-policy/",
        },
        {
          title: "Cookie Policy",
          link: "/cookie-policy/",
          // link: "/business/privacy-policy/",
        },
      ],
    },
    {
      title: "Popular",
      children: [
        {
          title: "Mobile Bundles",
          link: "/personal/mobile/offers/bundles/",
        },
        {
          title: "Apply for Broadband",
          link: "https://play.telecel.com.gh/pap/index.php?sid=check",
        },
        {
          title: "Your Business Online",
          link: "/business/products-and-solutions/your-business-online/",
        },
        {
          title: "2 Moorch Business",
          link: "/business/products-and-solutions/2-moorch-business/",
        },
      ],
    },
    {
      title: "Quicklinks",
      children: [
        {
          title: "Telecel Play",
          link: `${process.env.play_base_url}/dashboard/`,
        },
        {
          title: "Pay Bill",
          link: `${process.env.play_base_url}/pay/`,
        },
        {
          title: "Student Onboarding",
          link: "/business/onboarding/",
        },
        {
          title: "Wholesale Self-care",
          link: "/business/wholesale/",
        },
      ],
    },
  ]
  